import React, { useState } from "react"

import Layout from "../shared/components/organisms/layout/layout"
import SEO from "../shared/seo"
import SubLayout from "../components/molecules/sub-layout/sub-layout"
import PolygonTemplate from "../components/templates/polygon-template/polygon-template"
import Instructions from "../components/organisms/instructions/instructions"

import useMediaQuery from "../utils/useMediaQuery"
import { activitySEO } from "./../constants/activity-constants"
import useModalContext from "../utils/useModalContext"
import { Context } from "../context/app-context"

const ComoParticipo = () => {
  const isMobile = useMediaQuery()
  const modalActive = useModalContext(Context)

  return (
    <Layout mobile={isMobile} modalActive={modalActive}>
      <SEO
        url={activitySEO.url}
        title={activitySEO.title}
        description={activitySEO.description}
      />
      <SubLayout isMobile={isMobile}>
        <PolygonTemplate>
          <Instructions isMobile={isMobile} />
        </PolygonTemplate>
      </SubLayout>
    </Layout>
  )
}

export default ComoParticipo
